export enum ResetPasswordResponseType {
  SUCCESS = 'SUCCESS',
  EMAIL_INVALID = 'EMAIL_INVALID',
  LOGIN_DISABLED = 'LOGIN_DISABLED',
  EMAIL_PASSWORD_LOGIN_DISABLED = 'EMAIL_PASSWORD_LOGIN_DISABLED'
}